export const state = {
  confirmation: null,
  showConfirm: false,
  confirmAction: "",
  confirmObject: null,
  showOnboarding: false,
  onboardingUserName: "",
  // The deprecation notice is shown to anyone not signed in to this retired
  // app. Dismissing it lasts for the page, not forever: a blocked sign-in
  // raises it again, which is how someone learns why their login did not take.
  deprecationDismissed: false
};

export const mutations = {
  SET_CONFIRMATION(state, confirmation) {
    if (confirmation) {
      state.showConfirm = true;
      state.confirmation = confirmation;
      state.confirmAction = confirmation.action;
      state.confirmObject = confirmation.object;
    }
  },
  CLEAR_CONFIRMATION(state) {
    state.showConfirm = false;
    state.confirmPromise = null;
    state.confirmAction = "";
    state.confirmObject = null;
  },
  SHOW_REAUTH_LOGIN(state, message) {
    // This mutation is used to trigger the login modal with a reauth message
    // The actual state is managed in App.vue via store.subscribe
    console.log("Showing reauth login:", message);
  },
  SHOW_ONBOARDING(state, userName) {
    state.showOnboarding = true;
    state.onboardingUserName = userName || "";
  },
  HIDE_ONBOARDING(state) {
    state.showOnboarding = false;
    state.onboardingUserName = "";
  },
  DISMISS_DEPRECATION(state) {
    state.deprecationDismissed = true;
  },
  SHOW_DEPRECATION(state) {
    state.deprecationDismissed = false;
  }
};

export const actions = {
  showConfirmation({ commit }, confirmation) {
    console.log("confirming");
    if (!state.confirmAction) {
      commit("SET_CONFIRMATION", confirmation);
    }
  },
  confirm({ commit, dispatch }, response) {
    console.log(state.confirmAction, state.confirmObject);
    if (state.confirmAction && response)
      dispatch(state.confirmAction, state.confirmObject);
    commit("CLEAR_CONFIRMATION");
  },
  showReauthLogin({ commit }) {
    const message =
      "You have not logged in recently enough to proceed with account deletion. Please login again to proceed.";
    commit("SHOW_REAUTH_LOGIN", message);
  },
  showOnboarding({ commit }, userName) {
    commit("SHOW_ONBOARDING", userName);
  },
  hideOnboarding({ commit }) {
    commit("HIDE_ONBOARDING");
  },
  dismissDeprecation({ commit }) {
    commit("DISMISS_DEPRECATION");
  }
};

export const getters = {
  showConfirm(state) {
    return state.showConfirm;
  },
  confirmation(state) {
    return state.confirmation;
  },
  showOnboarding(state) {
    return state.showOnboarding;
  },
  onboardingUserName(state) {
    return state.onboardingUserName;
  },
  deprecationDismissed(state) {
    return state.deprecationDismissed;
  }
};
